import { debounceTime, Subject } from 'rxjs';
import { ConditionItem } from './condition-item';
import { CoordinatorService, MANIFEST_STORE_DELAY } from './coordinator.service';

export type CSTORAGE = { id?: string; templateId: string };

export class ConditionStorage {
    id: string;
    templateId: string;

    private _conditionItemMap = new Map<string, ConditionItem>();

    private _markForManifestStoreSubject$ = new Subject<void>();
    private _markForManifestStore$ = this._markForManifestStoreSubject$.pipe(
        debounceTime(MANIFEST_STORE_DELAY),
    );

    constructor(
        private coords: CoordinatorService,
        { id, templateId }: CSTORAGE,
    ) {
        this.id = id || coords.uniqueId();
        this.templateId = templateId;

        this._markForManifestStore$.subscribe(() => this._manifestStore());
    }

    markForManifestStore() {
        this._markForManifestStoreSubject$.next();
    }

    manifestDelete() {
        return {
            id: this.id,
            type: 'condition-storage',
        };
    }

    delete() {}

    private _manifestStore() {
        const payload = this.save();
        if (!payload) {
            this.coords.manifest$.delete([this.manifestDelete()]);
            return;
        }
        this.coords.manifest$.store({
            type: 'condition-storage',
            id: this.id,
            valueMap: new Map<string, any>([['conditionStorage', payload]]),
        }); 
    }

    save() {
        if (!this._conditionItemMap.size) return;

        return {
            id: this.id,
            templateId: this.templateId,
            ownerId: this.coords.user$.currentId,
            conditionItemLs: Array.from(this._conditionItemMap.values()).map((citm) => citm.save()),
        };
    }

    update(citm: ConditionItem, isLoad = false) {
        this._conditionItemMap.set(citm.id, citm);
        !isLoad && this.markForManifestStore();
    }
}
